import { createJSONRequest } from './create-request.js'

/**
 * An actor's technology roadmap: adoption status, operational area and start year per technology.
 *
 * Stored apart from the actor's technology classification, because that classification is
 * detached and rebuilt on every actor save — writing here never disturbs it, and vice versa.
 */
export const fetchActorTechnologyAdoptions = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/technology-adoptions`,
  method: 'GET',
})

/**
 * Replaces the whole roadmap. Technologies absent from the payload are removed, which is how a
 * row gets taken off the roadmap.
 */
export const updateActorTechnologyAdoptions = (actorId, adoptions) => createJSONRequest({
  url: `/api/actors/${actorId}/technology-adoptions`,
  method: 'PUT',
  data: { adoptions },
})
